// src/modules/helpdesk/shared.js — Helpers compartilhados V2-T (SLA/score/chips/categorias).
import { sb } from '../../api/supabaseClient.js';
import { uiIco } from '../../lib/uiIcons.js';

export function _chFormatDur(h) {
  if (h < 1) return Math.round(h * 60) + 'm';
  if (h < 24) return h.toFixed(1).replace(/\.0$/, '') + 'h';
  const d = Math.floor(h / 24), hr = Math.floor(h - d * 24);
  return d + 'd ' + hr + 'h';
}
export function _chSLAChip(ch) {
  if (['resolvido', 'fechado'].includes(ch.status)) {
    if (ch.resolvido_em && ch.sla_resolucao) {
      const dt = (new Date(ch.sla_resolucao) - new Date(ch.resolvido_em)) / 3600000;
      if (dt >= 0) return { cls: 'done', txt: uiIco('check',12) + ' Em ' + _chFormatDur(dt) };
      return { cls: 'done', txt: uiIco('check',12) + ' Resolvido' };
    }
    return { cls: 'done', txt: uiIco('check',12) + ' Resolvido' };
  }
  if (!ch.sla_resolucao) return { cls: 'ok', txt: '—' };
  const d = (new Date(ch.sla_resolucao) - new Date()) / 3600000;
  if (d < 0) return { cls: 'vencido', txt: uiIco('warn',12) + ' Vencido ' + _chFormatDur(Math.abs(d)) };
  if (d < 2) return { cls: 'crit', txt: _chFormatDur(d) };
  if (d < 8) return { cls: 'warn', txt: _chFormatDur(d) };
  return { cls: 'ok', txt: _chFormatDur(d) };
}
export function _chScoreUrgencia(ch, planoEmp) {
  if (['resolvido', 'fechado'].includes(ch.status)) return 0;
  let sc = 0;
  sc += ({ urgente: 40, alta: 30, normal: 15, baixa: 5 })[ch.prioridade] || 0;
  if (ch.sla_resolucao) {
    const d = (new Date(ch.sla_resolucao) - new Date()) / 3600000;
    if (d < 0) sc += 30; else if (d < 2) sc += 25; else if (d < 8) sc += 15; else if (d < 24) sc += 8;
  }
  sc += ({ enterprise: 20, empresa: 18, obra: 12, canteiro: 8, trial: 5 })[planoEmp || ch.empresas?.plano] || 0;
  if (ch.created_at) {
    const hAtras = (new Date() - new Date(ch.created_at)) / 3600000;
    if (hAtras > 48) sc += 10; else if (hAtras > 24) sc += 6; else if (hAtras > 8) sc += 3;
  }
  return Math.min(100, Math.round(sc));
}
export function _chScoreChip(s) {
  const cls = s >= 75 ? 'hi' : s >= 50 ? 'mid' : 'lo';
  return '<span class="v2t-score ' + cls + '">' + s + '</span>';
}
export function _chTipoChip(t) {
  const lbl = { bug: uiIco('bug',12) + ' BUG', duvida: uiIco('help',12) + ' DÚVIDA', sugestao: uiIco('bulb',12) + ' SUGESTÃO', melhoria: uiIco('sparkles',12) + ' MELHORIA' }[t] || t;
  return '<span class="v2t-chip tipo-' + (t || 'duvida') + '">' + lbl + '</span>';
}
export function _chPrioChip(p) {
  const lbl = { baixa: 'BAIXA', normal: 'NORMAL', alta: 'ALTA', urgente: 'URGENTE' }[p] || p;
  return '<span class="v2t-chip prio-' + (p || 'normal') + '">' + lbl + '</span>';
}
export function _chStatusChip(s) {
  const lbl = { aberto: uiIco('alert',12) + ' Aberto', analise: uiIco('search',12) + ' Análise', andamento: uiIco('gear',12) + ' Andamento', aguardando: uiIco('hourglass',12) + ' Aguardando', resolvido: uiIco('check',12) + ' Resolvido', fechado: uiIco('square',12) + ' Fechado' }[s] || s;
  return '<span class="v2t-chip st-' + (s || 'aberto') + '">' + lbl + '</span>';
}
export function _chEmpAvatar(nome) {
  // paleta de avatar: cor chapada (gradiente é proibido no design system)
  const palettes = ['var(--sc-info)', 'var(--sc-ok)', 'var(--sc-warn)', 'var(--sc-bad)', 'var(--sc-idle)'];
  let h = 0;
  for (let i = 0; i < (nome || '').length; i++) h = ((h << 5) - h + nome.charCodeAt(i)) | 0;
  const idx = Math.abs(h) % palettes.length;
  let ini = (nome || '?').trim().split(/\s+/).slice(0, 2).map((w) => w.charAt(0).toUpperCase()).join('');
  if (ini.length === 1) ini = (nome || '?').slice(0, 2).toUpperCase();
  return '<div class="v2t-emp-av" style="background:' + palettes[idx] + '">' + ini + '</div>';
}
export function _kbInferirCategorias(texto) {
  const t = (texto || '').toLowerCase();
  const cats = [];
  const patterns = {
    financeiro: /\b(financ|contas?\s?(a\s)?(pagar|receber)|cr\b|cp\b|nfse|nota\s?fiscal|aditivo|medi[çc][ãa]o|inss|iss|irrf|retenç[ãa]o|asaas|conciliaç[ãa]o|boleto|pix|fluxo|caixa)\b/i,
    rh: /\b(rh|funcion[áa]rio|ponto|holerite|f[ée]rias|aso|nr-?(06|10|18|35)|jornada|hora\s?extra|banco\s?de\s?horas|admiss[ãa]o|demiss[ãa]o|atestado|falta)\b/i,
    obras: /\b(obra|rdo|etapa|tarefa|cronograma|curva\s?s|supervisor|garantia|boletim|empreitada|cliente\s?da\s?obra)\b/i,
    mobile: /\b(mobile|celular|app|iphone|ios|android|tablet|notch|safe\s?area)\b/i,
    login: /\b(login|senha|esqueci|jwt|token|auth|sess[ãa]o|2fa|sso|recuperar)\b/i,
    performance: /\b(lent[oa]|trav|performance|p[ée]rfomanc|carregar?|demora|timeout|404|500|erro\s?500|loop)\b/i,
  };
  Object.keys(patterns).forEach((k) => { if (patterns[k].test(t)) cats.push(k); });
  if (!cats.length) cats.push('outros');
  return cats;
}
export function _kbCategoriaChip(cat) {
  const lbl = { financeiro: '💰 Financeiro', rh: '👥 RH', obras: '🏗 Obras', mobile: '📱 Mobile', login: '🔐 Login', performance: '⚡ Performance', outros: '📌 Outros' }[cat] || cat;
  return '<span class="v2t-cat ' + cat + '">' + lbl + '</span>';
}
export async function _chTemNovaRespostaSuporte(chId) {
  try {
    const r = await sb.from('suporte_comentarios').select('*,users_profile(tipo_usuario)').eq('chamado_id', chId).eq('interno', false).order('created_at', { ascending: false }).limit(1);
    if (!r.data || !r.data.length) return false;
    return r.data[0].users_profile?.tipo_usuario === 'super_admin';
  } catch (e) { return false; }
}
// Expor no window (alguns onclick inline e o drawer dependem)
Object.assign(window, { _chFormatDur, _chSLAChip, _chScoreUrgencia, _chScoreChip, _chTipoChip, _chPrioChip, _chStatusChip, _chEmpAvatar, _kbInferirCategorias, _kbCategoriaChip });
